import cn from 'classnames';
import { type FC } from 'react';

import { SocialProofTile, type SocialProofTileProps } from '../SocialProofTile';

export type SocialProofColumnProps = {
  column: SocialProofTileProps[];
  className?: string;
};

export const SocialProofColumn: FC<SocialProofColumnProps> = ({ column, className }) => {
  const hasTwoTiles = column.length === 2;

  return (
    <div className={cn(
      'flex',
      hasTwoTiles && 'flex-col gap-xs',
      className
    )}>
      {column.map(tile =>
        <SocialProofTile key={tile.logo} {...tile} />
      )}
    </div>
  );
};
